import React, { Component } from 'react'
import { node, string } from 'prop-types'
import ErrorView from './Error'

class ErrorBoundary extends Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    this.setState({ hasError: true })
  }

  render () {
    const { hasError } = this.state
    const { children, site } = this.props

    return hasError ? <ErrorView site={site} /> : children
  }
}

ErrorBoundary.propTypes = {
  children: node,
  site: string
}

export default ErrorBoundary